var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 2C5.75 1.58579 5.41421 1.25 5 1.25C4.58579 1.25 4.25 1.58579 4.25 2V22C4.25 22.4142 4.58579 22.75 5 22.75C5.41421 22.75 5.75 22.4142 5.75 22V12.1875L5.90393 12.226C7.95258 12.7381 10.0743 12.8926 12.1755 12.6824C13.3888 12.5611 14.6112 12.5611 15.8245 12.6824L17.9005 12.89C18.4892 12.9489 19 12.4866 19 11.895V3.90499C19 3.39124 18.6107 2.96107 18.0995 2.90995L15.8245 2.68245C14.6112 2.56112 13.3757 2.56243 12.1624 2.68376C10.0848 2.89152 7.96432 2.74108 5.93865 2.23466C5.87515 2.21879 5.81191 2.21142 5.75 2.21174V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.062e3a328c4f0d2a5d362acfffc84df1.svg";
export { ForwardRef as ReactComponent };